export function applyDesignSystemClasses(html: string): string {
  if (!html.includes('<')) {
    return html;
  }

  const designSystemMappings = [
    { tag: 'a', className: 'webex-link' },
    { tag: 'ul', className: 'webex-list-disc' },
  ];

  // Apply each design system class to its corresponding tag
  return designSystemMappings.reduce((processedHtml, { tag, className }) => {
    const pattern = new RegExp(`<${tag}([^>]*)>`, 'g');

    return processedHtml.replace(pattern, (match, attributes) => {
      if (attributes.includes('class="')) {
        return match.replace(/class="([^"]*)"/, `class="${className} $1"`);
      }

      return `<${tag}${attributes} class="${className}">`;
    });
  }, html);
}
